import { defineComponent as _defineComponent } from 'vue'
import { ObjectType, ModuleStreamingChartEdges } from '@/@types/graphql-types';
import { provideStreamingChartSpinningText, sliceTitles } from '@/helpers/streaming-chart-helper';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import TitleDetailStreamingChartListV2 from '@/pages/titleDetailV1/v1/streaming-chart/TitleDetailStreamingChartListV2.vue';
import { computed } from 'vue';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';


export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailStreamingChartV2',
  props: {
    titleId: { default: '' },
    titleName: null,
    streamingCharts: null,
    titleObjectType: null,
    isSidebar: { type: Boolean, default: false }
  },
  setup(__props: any, { expose }) {

const props = __props as { titleId: string, titleName: string, streamingCharts: ModuleStreamingChartEdges[], titleObjectType: ObjectType | undefined, isSidebar: boolean };



const streamingChartsRank = computed(() => props.streamingCharts[0]?.rankInfo?.rank);

const streamingChartTitles = computed(() => sliceTitles(props.titleId, props.streamingCharts, 4));

const renderChart = computed(
	() => streamingChartTitles.value?.length > 0 && !!streamingChartsRank.value && streamingChartsRank.value < 10000
);

const streamingChartLastUpdated = computed(() => {
	const title = props.streamingCharts.find(title => title?.jwEntityID === props.titleId);

	return title?.rankInfo?.updatedAt || '';
});

const titleDetailTitle = computed(() => {
	return streamingChartTitles.value?.find(title => {
		return title.jwEntityID === props.titleId;
	});
});

const titleNodes = computed(() => {
	return streamingChartTitles.value;
});

function trackClick(event: { index: number; title: ModuleStreamingChartEdges }) {
	TrackingHelper.trackEvent('userinteraction', {
		action: 'title_clicked',
		label: `${props.titleId}, ${event.title.jwEntityID}`,
		property: 'streaming_chart',
		value: event.index,
	});
}

expose({ renderChart });

return { __sfc: true,props, streamingChartsRank, streamingChartTitles, renderChart, streamingChartLastUpdated, titleDetailTitle, titleNodes, trackClick, provideStreamingChartSpinningText, TitleDetailStreamingChartListV2, faInfoCircle }
}

})